import React, { useEffect, useState } from 'react';
import { Row, Col, Accordion, Dropdown, OverlayTrigger, Tooltip } from 'react-bootstrap';
import smalllogo from "../../src/styles/images/logosmall.svg";
import app from "../../src/styles/images/app.svg";
import styles from "./scss/leftmenu.module.scss";
import { useSelector, useDispatch } from 'react-redux';
import { updateUserType } from '../store/login';


import logofull from "../styles/images/logofull.svg";
import menu from "../styles/images/menu/menu.svg";
import menu1 from "../styles/images/menu/menu1.svg";
import menu3 from "../styles/images/menu/menu3.svg";
import menu4 from "../styles/images/menu/menu4.svg";
import menu5 from "../styles/images/menu/menu5.svg";
import menu6 from "../styles/images/menu/menu6.svg";
import menu9 from "../styles/images/menu/menu9.svg";
import menudash from "../styles/images/menu/menudash.svg";
import menuactive from "../styles/images/menu/menuactive.svg";
import menu1active from "../styles/images/menu/menu1active.svg";
import menu3active from "../styles/images/menu/menu3active.svg";
import menu4active from "../styles/images/menu/menu4active.svg";
import menu5active from "../styles/images/menu/menu5active.svg";
import menu6active from "../styles/images/menu/menu6active.svg";
import menu9active from "../styles/images/menu/menu9active.svg";
import menudashactive from "../styles/images/menu/menudashactive.svg";
import { NavLink } from 'react-router-dom';
import { useNavigate } from "react-router-dom";
import { API_ROUTE_CONTROLLER } from '../app/base/routes';
import { ApiServices } from '../app/base/service/apiService';
import { updateOrderExtension } from '../store/auto';
import { calvaryComp_Id } from '../service/constant';


const LeftMenus = ({ showmenus = () => {} }) => {
	const dispatch = useDispatch();
	const _login = useSelector((state: any) => state.login.login)
	const _constant = useSelector((state: any) => state.constant.products[0]);
	console.log("_constant", _constant)
	const [accnav, setAccnav] = useState(false);
	const [usernav, setUsernav] = useState(false);
	const [numnav, setNumnav] = useState(false);
	const [subnav, setSubnav] = useState(false);
	const [accmaindev, setAccmaindev] = useState(false);
	const [usermaindev, setUsermaindev] = useState(false);
	const [nummaindev, setNummaindev] = useState(false);
	const [submaindev, setSubmaindev] = useState(false);
	// const [productId, setProductId] = useState<any>(15);
	const [productId, setProductId] = useState<any>(_constant?.product_id);

	// let productId =null;
	console.log("productIdproductId", productId)
	const [RoleName, setRoleName] = useState<any>('')
	console.log("_login_login_login", _login)
	const navigate = useNavigate();
	const [activeKey, setActiveKey] = useState(null);
    console.log("activeKey",activeKey)
	const toggleAccordion = (key) => {
	  setActiveKey(activeKey === key ? null : key);
	};
	const accmenu = () => {
		setAccnav(true);
		setActiveKey(null);
	}
	const usermenu = () => {
		setUsernav(true);
		setActiveKey(null);
		

	}
	const nummenu = () => {
		setNumnav(true);
		setActiveKey(null);

	}
	const submenu = () => {
		setSubnav(true);
		setActiveKey(null);

	}
	const usermenumain = () => {
		setAccnav(false);
		setNumnav(false);
		setSubnav(false);
		setUsermaindev(true);
	}
	const nummenumain = () => {
		setAccnav(false);
		setUsernav(false);
		setSubnav(false);
		setNummaindev(true);
	}
	const submenumain = () => {
		setAccnav(false);
		setUsernav(false);
		setNumnav(false);
		setSubmaindev(true);
	}
	const accmenumain = () => {
		setUsernav(false);
		setNumnav(false);
		setSubnav(false);
		setAccmaindev(true);
	}
	const plainmenumain = () => {
		setAccnav(false);
		setUsernav(false);
		setNumnav(false);
		setSubnav(false);
		setUsermaindev(false);
		setAccmaindev(false);
		setNummaindev(false);
		setSubmaindev(false);
	}

	const getUsersApi = async () => {
		let _url = API_ROUTE_CONTROLLER.Urmyaccwebuserorderextension;
		let _body = {
			"OrderId": _login.order_id,
			"Order_Type": '2'
		};
		ApiServices.post(_body, _url).then(async (value: any) => {
			console.log("value", value)
			if (value?.data?.finalresponse && value?.data?.finalresponse.length) {
				localStorage.setItem("orderExt", JSON.stringify(value?.data?.finalresponse));
				dispatch(updateOrderExtension(value?.data?.finalresponse));
			  }	
			// const jsonProduct: any = value.data.finalresponse[0].jsonproduct;
			// console.log("jsonProduct", jsonProduct)
			// if (!jsonProduct) {
			// 	return '';
			// }
			// const myArray: any = Array.from(JSON.parse(jsonProduct));
			// console.log("myArray", myArray)
			// setProductId(myArray[0].Productid);
			// productId = myArray[0].Productid;
		}).catch((error) => {
			console.log("errorerror", error);
		});
	};


	const get_user_with_extensionsdata = async () => {
		const url = API_ROUTE_CONTROLLER.Urmyaccwebgetuserextensioninfo;
		const body = {
			"company_id": _login.company_id,
			"orderid": _login.order_id,
			"extension_number": _login.extension
		};
		ApiServices.post(body, url).then(async (value: any) => {
			//console.log("userInfo", value.data.finalresponse[0].Email);
			let role = JSON.parse(value.data.finalresponse[0].jsonproduct)
			console.log(role)
			// console.log(role[0].RoleName)
			setRoleName(role[0]?.RoleName)

		});
	};

	useEffect(() => {
		getUsersApi();
		get_user_with_extensionsdata()
	}, [])


	const [closing, setClosing] = useState(false);
	const closingmenu = () => {
		setClosing(!closing);
		showmenus()
		setActiveKey(null)
		
		
	}

	const gotomyacount = () => {
		dispatch(updateUserType("Company"));
		navigate('/overview');
	}
	const gotoWorktualapp = () => {
		window.open('https://app.worktual.co.uk/chats', '_blank');
	}

	const gotoCcaasApp = () => {
		if (RoleName == "Admin" || RoleName == "Owner") {
			window.open('https://ccaas.worktual.co.uk/dashboard', '_blank');
		} else {
			window.open('https://ccaas.worktual.co.uk/agentDashboard', '_blank');
		}
	}


	console.log("asasdasd", window.location.pathname)
	let dashurl;
	if (`/dashboard` == window.location.pathname) {
		dashurl = "active";
	} else {

	}


	const [isMobile, setIsMobile] = useState(window.innerWidth < 767);
	useEffect(() => {
		window.addEventListener("resize", () => {
			const ismobile = window.innerWidth < 767;
			if (ismobile !== isMobile) setIsMobile(ismobile);
		}, false);
	}, [isMobile]);

	return (
		<>


			{!closing ?
				<div className={styles.leftbars}>
					<div className={styles.columnpads}>
						{/* <img src={logofull} className={`${styles.logofull} biglogo`} onClick={() => navigate('/overview')} />
						<img src={smalllogo} className={`${styles.logos} smalllogo`} onClick={() => navigate('/overview')} /> */}
						<ul className="sidebars">
						<Accordion activeKey={activeKey}>
						<li className={dashurl}><NavLink to="/overview" onClick={isMobile ? closingmenu : plainmenumain}><img src={menudash} /><img src={menudashactive} className="imgactive" />Dashboard</NavLink></li>
								<Accordion.Item eventKey="0" className={false ? "showAcc" : "hideAcc"} id={accmaindev ? "showingAcc" : "HiddenAcc"} onClick={accmenumain}>
									<Accordion.Header onClick={() => {toggleAccordion("0")}}>{!accnav ? <img src={menu1} />:<img src={menu1active} />}Account Management</Accordion.Header>
									<Accordion.Body>
										<li><NavLink to="/account-information" onClick={isMobile ? closingmenu : accmenu}>Account Info</NavLink></li>

										<Accordion className="inneraccordion">
											{
												productId == 2 ?
													<Accordion.Item eventKey="01">
														<Accordion.Header onClick={() => {toggleAccordion("01")}}>Account Settings</Accordion.Header>
														<Accordion.Body>
															<>
																{/* <li><NavLink to="#">Call Queue</NavLink></li> */}
																< li > <NavLink to="/accountmanagent/auto" onClick={isMobile ? closingmenu : accmenu}>Auto Receptionist</NavLink></li>
																< li > <NavLink to="/recordings" onClick={isMobile ? closingmenu : accmenu}>Recording</NavLink></li>
																<li><NavLink to="/huntgroup" onClick={isMobile ? closingmenu : accmenu}>Hunt Group</NavLink></li>
																<li><NavLink to="/parklocation" onClick={isMobile ? closingmenu : accmenu}>Park Location</NavLink></li>
																{/* <li><NavLink to="/directrouting" onClick={isMobile ? closingmenu : accmenu}>Teams Integration</NavLink></li> */}

															</>
														</Accordion.Body>
													</Accordion.Item>
													: productId == 15 ?
														<></>
														: productId == 1 ?
															<></>
															: ""
											}
											<li><NavLink to="/activitylog" onClick={isMobile ? closingmenu : accmenu}>Activity Log</NavLink></li>
											{productId == 2 ? <li><NavLink to="/call_log" onClick={isMobile ? closingmenu : accmenu}>Call Logs</NavLink></li>  : <></>}
										</Accordion>

									</Accordion.Body>
								</Accordion.Item>

								<Accordion.Item eventKey="1" className={false ? "showAcc" : "hideAcc"} id={usermaindev ? "showingAcc" : "HiddenAcc"} onClick={usermenumain}>
									<Accordion.Header onClick={() => toggleAccordion("1")}>{!usernav ?<img src={menu} />:<img src={menuactive} />}User Management</Accordion.Header>
									<Accordion.Body>
										<li><NavLink to="/usermanagement" onClick={isMobile ? closingmenu : usermenu}>Users</NavLink></li>
										{/* <li><NavLink to="/role" onClick={isMobile ? closingmenu : usermenu}>Roles & Permissions</NavLink></li> */}
										<li><NavLink to="/custom-fields" onClick={isMobile ? closingmenu : usermenu}>Custom Fields</NavLink></li>
									</Accordion.Body>
								</Accordion.Item>
								{
									productId == 15 ? "" :
										<Accordion.Item eventKey="2" className={false ? "showAcc" : "hideAcc"} id={nummaindev ? "showingAcc" : "HiddenAcc"} onClick={nummenumain}>
											<Accordion.Header onClick={() => toggleAccordion("2")}>{!numnav ?<img src={menu5} />:<img src={menu5active}  />}Number Management</Accordion.Header>
											<Accordion.Body>
												<li><NavLink to="/number-management" onClick={isMobile ? closingmenu : nummenu}>Numbers</NavLink></li>
												{
													_constant?.company_id != calvaryComp_Id && <>
													
													{/* <li><NavLink to="/port-in" onClick={isMobile ? closingmenu : nummenu}>Port-In</NavLink></li> */}
													{productId == 1 && productId != 15 && productId != 2 ? <li><NavLink to="/siptrunck" onClick={isMobile ? closingmenu : nummenu}>Sip Trunk</NavLink></li> : ""}
													</>
												}
												{/* <li className="nomobile"><NavLink to="/conference-bridge" onClick={isMobile ? closingmenu : nummenu}>Conference Bridge</NavLink></li> */}
											</Accordion.Body>
										</Accordion.Item>
								}
								{
									productId == 15 && _constant.v_isSms == 1 ?
										<Accordion.Item eventKey="2" className={false ? "showAcc" : "hideAcc"} id={nummaindev ? "showingAcc" : "HiddenAcc"} onClick={nummenumain}>
											<Accordion.Header onClick={() => toggleAccordion("2")}>{!numnav?<img src={menu5} />:<img src={menu5active}  />}Number Management</Accordion.Header>
											<Accordion.Body>
												<li><NavLink to="/number-management" onClick={isMobile ? closingmenu : nummenu}>Numbers</NavLink></li>
												{/* <li className="nomobile"><NavLink to="/port-in" onClick={isMobile ? closingmenu : nummenu}>Port-In</NavLink></li> */}
												{productId == 1 && productId != 15 && productId != 2 ? <li className="nomobile"><NavLink to="/siptrunck" onClick={isMobile ? closingmenu : nummenu}>Sip Trunk</NavLink></li> : ""}
												{/* <li className="nomobile"><NavLink to="/conference-bridge" onClick={isMobile ? closingmenu : nummenu}>Conference Bridge</NavLink></li> */}
											</Accordion.Body>
										</Accordion.Item> : ""
								}
								{/* {productId == 15 ? "" : <li><NavLink to="/device-management" onClick={isMobile ? closingmenu : plainmenumain}><img src={menu4} /><img src={menu4active} className="imgactive" />Device Management</NavLink></li>} */}
								{_constant?.company_id != calvaryComp_Id && 
								<Accordion.Item eventKey="3" className={false ? "showAcc" : "hideAcc"} id={submaindev ? "showingAcc" : "HiddenAcc"} onClick={submenumain}>
									<Accordion.Header onClick={() => toggleAccordion("3")}>{!subnav ? <img src={menu6} />:<img src={menu6active}  />}Subscription & Billing</Accordion.Header>
									<Accordion.Body>
										<li><NavLink to="/subscription-management" onClick={isMobile ? closingmenu : submenu}>Subscription Management</NavLink></li>
										<li><NavLink to="/purchasemain" onClick={isMobile ? closingmenu : submenu}>Purchase</NavLink></li>
										{_login.ccas_role_info == 1 ? <li><NavLink to="/subscription/billing_contact" onClick={isMobile ? closingmenu : submenu}>Billing Contacts</NavLink></li> : ""}
										<li><NavLink to="/subscriptionandbilling/payment" onClick={isMobile ? closingmenu : submenu}>Payments</NavLink></li>
										<li><NavLink to="/invoice" onClick={isMobile ? closingmenu : submenu}>Invoices</NavLink></li>
									</Accordion.Body>
								</Accordion.Item>
                                }

								{/* <li><NavLink to="/security" onClick={isMobile ? closingmenu : plainmenumain}><img src={menu3} /><img src={menu3active} className="imgactive" />Security</NavLink></li> */}
								{/* <li><NavLink to="/domain"><img src={menu2} /><img src={menu2active} className="imgactive" />Domains</NavLink></li> */}
								<li><NavLink to="/reports" onClick={isMobile ? closingmenu : plainmenumain}><img src={menu4} /><img src={menu4active} className="imgactive" />Reports</NavLink></li>
								{/* {productId == 1 || productId == 15 ? <li><NavLink to="/integration" onClick={isMobile ? closingmenu : plainmenumain}><img src={menu9} /><img src={menu9active} className="imgactive" />Social Media Integrations</NavLink></li> : ""} */}
							</Accordion>
						</ul>


						{productId == 2 ? <Dropdown className="bottomapp" drop="end">
							<Dropdown.Toggle variant="success" id="dropdown-basic">
								<p ><img src={app} />Worktual Switchers</p>
							</Dropdown.Toggle>
							<Dropdown.Menu className="bottomapppop">
								{/* {productId == 1 ?
									<ul>
		
										<li onClick={gotoCcaasApp}>
											<svg width="65" height="64" viewBox="0 0 65 64" fill="none" xmlns="http://www.w3.org/2000/svg">
												<path d="M32.9773 48.0688H19.1106C17.8965 48.0688 16.9114 47.0843 16.9114 45.8699V36H6.64583C8.58049 48.8248 19.616 58.6667 32.9805 58.6667C46.345 58.6667 57.3805 48.8248 59.3152 36H48.5266C46.7448 42.9357 40.4682 48.0688 32.9773 48.0688Z" fill="#00DEA0" />
												<path d="M32.9877 15.9311C40.4773 15.9311 46.7512 21.0647 48.5288 27.9999H59.3152C57.3805 15.1751 46.345 5.33325 32.9805 5.33325C19.616 5.33325 8.58049 15.1751 6.64583 27.9999H17.4354C19.2184 21.0639 25.4949 15.9311 32.9877 15.9311Z" fill="#00DEA0" />
												<path d="M32.9792 38.3775C32.2421 38.3775 31.6458 37.7812 31.6458 37.0442V26.9556C31.6458 26.2186 32.2421 25.6223 32.9792 25.6223C33.7162 25.6223 34.3125 26.2186 34.3125 26.9556V37.0442C34.3125 37.7812 33.7162 38.3775 32.9792 38.3775Z" fill="black" />
												<path d="M37.3906 36.1016C36.6536 36.1016 36.0573 35.5054 36.0573 34.7683V29.3907C36.0573 28.6536 36.6536 28.0574 37.3906 28.0574C38.1277 28.0574 38.724 28.6536 38.724 29.3907V34.7683C38.724 35.5054 38.1277 36.1016 37.3906 36.1016Z" fill="black" />
												<path d="M28.5781 36.1016C27.8411 36.1016 27.2448 35.5054 27.2448 34.7683V29.3907C27.2448 28.6536 27.8411 28.0574 28.5781 28.0574C29.3152 28.0574 29.9115 28.6536 29.9115 29.3907V34.7683C29.9115 35.5054 29.3152 36.1016 28.5781 36.1016Z" fill="black" />
												<path d="M24.1719 34.2785C23.4348 34.2785 22.8385 33.6823 22.8385 32.9452V31.1615C22.8385 30.4244 23.4348 29.8281 24.1719 29.8281C24.9089 29.8281 25.5052 30.4244 25.5052 31.1615V32.9452C25.5052 33.6823 24.9089 34.2785 24.1719 34.2785Z" fill="black" />
												<path d="M41.7969 34.2785C41.0598 34.2785 40.4635 33.6823 40.4635 32.9452V31.1615C40.4635 30.4244 41.0598 29.8281 41.7969 29.8281C42.5339 29.8281 43.1302 30.4244 43.1302 31.1615V32.9452C43.1302 33.6823 42.5339 34.2785 41.7969 34.2785Z" fill="black" />
											</svg>
											Contact Centre Platform
										</li>
									</ul> :
									productId == 15 ?
										<ul>
				
											<li onClick={gotoCcaasApp}>
												<svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
													<g clip-path="url(#clip0_4230_241595)">
														<path d="M48.0062 18.1432V26.8891C49.4576 26.7661 50.5971 25.688 50.5971 24.3603V20.672C50.5971 19.3443 49.4576 18.2661 48.0062 18.1432Z" fill="#00DEA0" />
														<path d="M16.0033 18.1432V26.8891C14.5519 26.7661 13.4124 25.688 13.4124 24.3603V20.672C13.4124 19.3443 14.5519 18.2661 16.0033 18.1432Z" fill="#00DEA0" />
														<path d="M33.9703 9.6252C33.9442 8.538 33.0535 7.6748 31.9703 7.6748H31.9207C30.8164 7.70227 29.9442 8.62014 29.9703 9.7244L30.0354 12.3793C30.0615 13.4665 30.9522 14.3297 32.0354 14.3297H32.085C33.1892 14.3023 34.0615 13.3844 34.0354 12.2801L33.9703 9.6252Z" fill="#00DEA0" />
														<path d="M46.4839 36.9814H36.4657V36.972H27.5335V36.9814H17.5153C14.8265 36.9814 12.6468 39.1611 12.6468 41.8499V44.4214H12.6625C12.7633 46.7416 13.3996 49.652 16.0057 52.0302C18.7655 54.548 23.4679 56.2208 31.2559 56.3206V56.3254H32.7441V56.3206C40.5319 56.2208 45.2343 54.548 47.9943 52.0302C50.6004 49.652 51.2364 46.7416 51.3375 44.4214H51.3532V41.8499C51.3532 39.1611 49.1727 36.9814 46.4839 36.9814Z" fill="#00DEA0" />
														<path fill-rule="evenodd" clip-rule="evenodd" d="M46.7924 20.1136L46.7978 20.3259C46.8159 21.0654 46.8159 21.7947 46.8159 22.5214C46.8303 23.1317 46.8179 23.7881 46.8056 24.4416C46.8047 24.4908 46.8038 24.54 46.8028 24.5891L46.7924 24.9315C46.7404 26.8024 46.6596 29.6307 43.9252 31.4171C41.506 33.0019 38.2559 33.184 35.4018 33.231C34.1412 33.2531 33.0658 33.2648 31.9903 33.2648C30.9124 33.2648 29.8394 33.2531 28.5738 33.231C25.7223 33.184 22.4748 33.0016 20.053 31.4171C17.3186 29.6294 17.2378 26.7984 17.1858 24.9262L17.178 20.3742C17.2378 18.2582 17.3186 15.4302 20.0503 13.6294C22.4748 12.0419 25.7223 11.8598 28.5764 11.8128C31.0996 11.7699 32.8759 11.7699 35.4044 11.8128C38.2559 11.8598 41.506 12.0422 43.9279 13.6267C46.6596 15.4144 46.7404 18.2424 46.7924 20.1136ZM23.9697 22.5161C23.9697 24.0561 25.2177 25.3044 26.7577 25.3044C28.2975 25.3044 29.5463 24.0559 29.5463 22.5161C29.5463 20.9764 28.2977 19.7279 26.7577 19.7279C25.2177 19.7279 23.9697 20.9761 23.9697 22.5161ZM34.4516 22.5161C34.4516 24.0561 35.6996 25.3044 37.2396 25.3044C38.7793 25.3044 40.0281 24.0559 40.0281 22.5161C40.0281 20.9764 38.7796 19.7279 37.2396 19.7279C35.6996 19.7279 34.4516 20.9761 34.4516 22.5161Z" fill="white" />
													</g>
													<defs>
														<clipPath id="clip0_4230_241595">
															<rect width="64" height="64" fill="white" />
														</clipPath>
													</defs>
												</svg>
												ChatBox
											</li>
										</ul> :""} */}


								<ul>

									<li onClick={gotoWorktualapp}>
										<svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg">
											<g clipPath="url(#clip0_571_97179)">
												<path d="M9.29761 9.40625H0V18.7031H9.29761V9.40625Z" fill="white" />
												<path d="M27.9992 5.09975V18.7031H18.5955V14.5005C18.5955 11.6854 16.3117 9.40183 13.4953 9.40183H9.29346V0H22.899C25.7154 0 27.9992 2.28362 27.9992 5.09975Z" fill="#00E2A4" />
												<path d="M18.5945 18.7031V28L9.29688 18.7031H18.5945Z" fill="#00E2A4" />
												<path d="M18.5955 14.501V18.7036L9.29346 9.40234H13.4953C16.3117 9.40234 18.5944 11.6849 18.5944 14.501" fill="white" />
											</g>
											<defs>
												<clipPath id="clip0_571_97179">
													<rect width="28" height="28" fill="white" />
												</clipPath>
											</defs>
										</svg>
										Worktual Web App
									</li>
								</ul>

							</Dropdown.Menu>
						</Dropdown> : ""}



					</div>
				</div >
				: ""}


		</>

	);
};
export default LeftMenus;